<mat-toolbar class="mat-toolbar-height">
    <div class="div-title">
        <mat-icon>trending_up</mat-icon>
        <span>{{'events.metric_add'|translate}}</span>
    </div>
    <span class="tracker-spacer"></span>
    <button mat-icon-button mat-dialog-close="false">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>


<form class="tracker-form">
    <div class="form-container">

        <form *ngIf="metric" class="form">  

            <!-- list -->
            <div *ngFor="let option of metric.payload" [style.width]="option.widthDiv">
                <ng-container [ngTemplateOutlet]="selectForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='select'">
                </ng-container>
                <ng-container [ngTemplateOutlet]="textForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='text'">
                </ng-container>
                <ng-container [ngTemplateOutlet]="textareaForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='textarea'">
                </ng-container>
                <ng-container [ngTemplateOutlet]="numberForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='number'">
                </ng-container>
                <ng-container [ngTemplateOutlet]="dateForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='date'">
                </ng-container>
                <!-- TODO: Error in template -->
                <!-- <ng-container [ngTemplateOutlet]="checkboxForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='checkbox'">
                </ng-container> -->
                <!-- TODO: implement these templates -->
                <!-- <ng-container [ngTemplateOutlet]="radioForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='radio'">
                </ng-container>
                <ng-container [ngTemplateOutlet]="colorsForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='colors'">
                </ng-container>
                <ng-container [ngTemplateOutlet]="colorForm" [ngTemplateOutletContext]="{config:option}"
                    *ngIf="option.type=='color'">
                </ng-container> -->
            </div>

            <!-- select -->
            <ng-template #selectForm let-config="config">
                <mat-form-field appearance="outline">
                    <mat-label>{{config.label}}</mat-label>
                    <ng-container *ngIf="config.multiple">
                        <mat-select matInput [(ngModel)]="config.value" [class]="config.customClass"
                            [ngModelOptions]="{standalone: true}" size="5" multiple>
                            <mat-option [value]="opt" *ngFor="let opt of config.options">{{opt}}</mat-option>
                        </mat-select>
                    </ng-container>
                    <ng-container *ngIf="!config.multiple">
                        <mat-select matInput [(ngModel)]="config.value" [ngModelOptions]="{standalone: true}">
                            <mat-option [value]="opt" *ngFor="let opt of config.options">{{opt}}</mat-option>
                        </mat-select>
                    </ng-container>
                </mat-form-field>
            </ng-template>

            <!-- text -->
            <ng-template #textForm let-config="config">
                <mat-form-field appearance="outline" class="" [style.width]="config.width">
                    <mat-label>{{config.label }}</mat-label>
                    <input matInput type="text" placeholder="0" [(ngModel)]="config.value"
                        [style.height]="config.height" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </ng-template>

            <!-- textarea -->
            <ng-template #textareaForm let-config="config">
                <mat-form-field appearance="outline" class="" [style.width]="config.width">
                    <mat-label>{{config.label }}</mat-label>
                    <textarea matInput placeholder="0" [(ngModel)]="config.value"
                        [style.height]="config.height"></textarea>
                </mat-form-field>
            </ng-template>

            <!-- number -->
            <ng-template #numberForm let-config="config">
                <mat-form-field appearance="outline" class="" [style.width]="config.width">
                    <mat-label>{{config.label}}</mat-label>
                    <input matInput type="number" placeholder="0" [(ngModel)]="config.value"
                        [ngModelOptions]="{standalone: true}" [min]="config.min !== undefined ? config.min : null"
                        [max]="config.max !== undefined ? config.max : null">
                </mat-form-field>
            </ng-template>

            <!-- date -->
            <ng-template #dateForm let-config="config">
                <div [style.width]="config.width">
                    <label>{{config.label}}</label>
                    <app-date-picker [startDate]="config.value" (change)="onDateChange($event, config)"></app-date-picker>
                </div>
            </ng-template>

            <!-- checkbox -->
            <!-- TODO: fix errors (e.g. inputList not defined..) -->
            <!-- <ng-template #checkboxForm let-config="config">
                <mat-checkbox [(ngModel)]="config.value" [ngModelOptions]="{standalone: true}"
                    [style.width]="config.width || '250px'" [class]="config.customClass">
                    {{config.label}}</mat-checkbox>
                <div class="group box-input" *ngIf="config.groupKey && config.value">
                    <ng-container [ngTemplateOutlet]="inputList"
                        [ngTemplateOutletContext]="{inputs:groups[config.group]}">
                    </ng-container>
                </div>
            </ng-template> -->

        </form>
    </div>
    
    <mat-dialog-actions class="btn-actions">
        <span class="tracker-spacer"></span>
        <button mat-flat-button color="primary" (click)="saveMetric()">{{'form.save'|translate}}</button>
        <button mat-button mat-dialog-close="false">{{'form.close'|translate}}</button>
    </mat-dialog-actions>
</form>